"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PeriodFact;
(function (PeriodFact) {
    PeriodFact["PERIOD_STARTED"] = "PERIOD_STARTED";
    PeriodFact["PERIOD_FINISHED"] = "PERIOD_FINISHED";
})(PeriodFact = exports.PeriodFact || (exports.PeriodFact = {}));
var ClockFact;
(function (ClockFact) {
    ClockFact["CLOCK_STARTED"] = "CLOCK_STARTED";
    ClockFact["CLOCK_STOPPED"] = "CLOCK_STOPPED";
    ClockFact["CLOCK_ADJUSTED"] = "CLOCK_ADJUSTED";
})(ClockFact = exports.ClockFact || (exports.ClockFact = {}));
var SubstitutionFact;
(function (SubstitutionFact) {
    SubstitutionFact["SUBSTITUTION"] = "SUBSTITUTION";
})(SubstitutionFact = exports.SubstitutionFact || (exports.SubstitutionFact = {}));
var BreakFact;
(function (BreakFact) {
    BreakFact["PLAYERS_ENTERING"] = "PLAYERS_ENTERING";
    BreakFact["ABOUT_TO_START"] = "ABOUT_TO_START";
})(BreakFact = exports.BreakFact || (exports.BreakFact = {}));
var LineupFact;
(function (LineupFact) {
    LineupFact["LINEUPS"] = "LINEUPS";
})(LineupFact = exports.LineupFact || (exports.LineupFact = {}));
var ProviderFact;
(function (ProviderFact) {
    ProviderFact["PROVIDER_CONNECTED"] = "PROVIDER_CONNECTED";
    ProviderFact["PROVIDER_DISCONNECTED"] = "PROVIDER_DISCONNECTED";
    ProviderFact["PROVIDER_CONNECTION_PROBLEMS"] = "PROVIDER_CONNECTION_PROBLEMS";
    ProviderFact["PROVIDER_MESSAGE"] = "PROVIDER_MESSAGE";
})(ProviderFact = exports.ProviderFact || (exports.ProviderFact = {}));
var SportFact;
(function (SportFact) {
    SportFact["PLAYERS_SHAKING_HANDS"] = "PLAYERS_SHAKING_HANDS";
    SportFact["VIDEO_REF_DELIBERATION"] = "VIDEO_REF_DELIBERATION";
    SportFact["MATCH_CANCELLED"] = "MATCH_CANCELLED";
    SportFact["ANTHEMS"] = "ANTHEMS";
})(SportFact = exports.SportFact || (exports.SportFact = {}));
//# sourceMappingURL=Facts.js.map